import { Box, Button, HStack, TextField, VStack } from '@medely/ui-kit';
import { FormProvider, useForm } from '@medely/ui-kit/react-hook-form';
import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useProNavigate } from '@mp/contexts';
import usePaymentInfo from '@mp/hooks/usePaymentInfo';
import {
  BankAccountFormT,
  BankAccountFormSchema,
} from '@mp/models/settings/financial/BankAccountForm.schema';

type Props = {
  onError: () => void;
  onSuccess: () => void;
};

export const BankAccountForm = ({ onError, onSuccess }: Props) => {
  const methods = useForm<BankAccountFormT>({ resolver: yupResolver(BankAccountFormSchema) });
  const { navigate } = useProNavigate();
  const { addDirectDeposit, isAddDirectDepositLoading } = usePaymentInfo();

  function onSubmit(data: BankAccountFormT) {
    if (!data.routing_number || !data.account_number) {
      onError();
      return;
    }

    const directDepositData = {
      routing_number: data.routing_number,
      account_number: data.account_number,
    };
    addDirectDeposit(directDepositData, {
      onSuccess: () => {
        methods.reset();
        onSuccess();
        navigate('PayoutTaxes');
      },
      onError,
    });
  }

  function onCancel() {
    navigate('PayoutTaxes');
  }

  return (
    <FormProvider {...methods}>
      <VStack gap={2}>
        <TextField name="routing_number" label="Routing number" />
        <TextField name="account_number" label="Account number" />
        <TextField name="confirm_account_number" label="Confirm account number" />
      </VStack>
      <Box mt={4} p={2}>
        <HStack gap={1}>
          <Box width={'50%'}>
            <Button variant="outlined" fullWidth onClick={onCancel}>
              Cancel
            </Button>
          </Box>
          <Box width={'50%'}>
            <Button
              fullWidth
              onClick={() => methods.handleSubmit(onSubmit)()}
              loading={isAddDirectDepositLoading}
            >
              Save
            </Button>
          </Box>
        </HStack>
      </Box>
    </FormProvider>
  );
};
